

























































































import { mapFields } from 'vuex-map-fields'
import ToggleThreeState from '@/components/ToggleThreeState.vue'

export default
    components: { ToggleThreeState }

    data: ->
        yesno: ['No', 'Yes']
        options_index: ['Absolute', 'Relative', 'Global']
        options_series: ['Movies', 'Both', 'Series']
        options_layout: ['Compact', 'Normal', 'Wide']

    computed: {
        ...mapFields('display', {
            'score_review'
            'score_imdb'
            'score_metacritic'
            'time_review'
            'time_release'
            'time_collection'
            'imdbyear'
            'genre'
            'runtime'
            'index'
            'group_by_year'
            'index_type'
            'movies_or_series'
            'layout'
        })
    }

